module.exports = __webpack_public_path__ + "static/media/swap.3144d028.png";